import { components } from "types/openapi";

export type TTemplate = components["schemas"]["ReportTemplateDto"];
export type TTemplateCode = components["schemas"]["ReportTemplateCardDto"];
export type TemplateFilesType = components["schemas"]["ReportTemplateCardDto"]["type"];

export enum TEMPLATE_TYPE_ENUM {
  REQUEST_REPORT_V1 = "REQUEST_REPORT_V1",
  REQUEST_REPORT_V2 = "REQUEST_REPORT_V2",
  TX_REPORT = "TX_REPORT",
  FEE_CURRENCY_REPORT = "FEE_CURRENCY_REPORT",
  FEE_CURRENCY_REPORT_EXTERNAL = "FEE_CURRENCY_REPORT_EXTERNAL",
  REPORT_REQUESTS = "REPORT_REQUESTS",
  REPORT_WALLETS = "REPORT_WALLETS",
  REPORT_COMPANIES = "REPORT_COMPANIES",
  REPORT_COMPANIES_TOTAL = "REPORT_COMPANIES_TOTAL",
  DKP = "DKP",
  PP_SENT_IMP = "PP_SENT_IMP",
  PP_SENT_EXP = "PP_SENT_EXP",
  PP_RECEIVED_IMP = "PP_RECEIVED_IMP",
  PP_RECEIVED_EXP = "PP_RECEIVED_EXP",
  FEE_CUR_ALL = "FEE_CUR_ALL",
  REPORT_REQUESTS_BY_CONTRACT = "REPORT_REQUESTS_BY_CONTRACT",
  ACCOUNT_MOVEMENT_REPORT = "ACCOUNT_MOVEMENT_REPORT",
  LP_ACCOUNT_MOVEMENT_REPORT = "LP_ACCOUNT_MOVEMENT_REPORT",
  CUSTOMER_ACCOUNT_MOVEMENT_REPORT = "CUSTOMER_ACCOUNT_MOVEMENT_REPORT",
}

const titleTemplates: Record<TEMPLATE_TYPE_ENUM, string> = {
  FEE_CUR_ALL: "Отчёт по комиссиям всех компаний",
  REPORT_REQUESTS_BY_CONTRACT: "Отчёт о заявках по договору",
  ACCOUNT_MOVEMENT_REPORT: "Отчёт по движению средств на счёте",
  REQUEST_REPORT_V1: "Отчёт о заявках (v1)",
  DKP: "Договор купли-продажи",
  PP_SENT_IMP: "Платёжное поручение на списание денежных средств (импорт)",
  PP_SENT_EXP: "Платёжное поручение на списание денежных средств (экспорт)",
  PP_RECEIVED_IMP: "Платёжное поручение на списание цифровой валюты (импорт)",
  PP_RECEIVED_EXP: "Платёжное поручение на списание цифровой валюты (экспорт)",
  REQUEST_REPORT_V2: "Отчёт о заявках (v2)",
  TX_REPORT: "Отчёт по операциям",
  FEE_CURRENCY_REPORT: "Отчёт по текущим комиссиям",
  FEE_CURRENCY_REPORT_EXTERNAL: "Отчёт по комиссиям (внешний)",
  REPORT_REQUESTS: "Отчёт о заявках",
  REPORT_WALLETS: "Отчёт по кошелькам",
  REPORT_COMPANIES: "Отчёт по компаниям",
  REPORT_COMPANIES_TOTAL: "Сводный отчёт по компаниям",
  LP_ACCOUNT_MOVEMENT_REPORT: "Отчет по движению средств на счете",
  CUSTOMER_ACCOUNT_MOVEMENT_REPORT: "Отчет по движению средств на счете",
};

export enum SmsTemplateType {
  LOGIN = "LOGIN",
  LEGALLY_SIGNIFICANT_ACTION = "LEGALLY_SIGNIFICANT_ACTION",
  COMMON_ACTION = "COMMON_ACTION",
}

export const SMS_TYPE_TEXT = {
  LOGIN: "Авторизация",
  LEGALLY_SIGNIFICANT_ACTION: "Юридически значимые действия",
  COMMON_ACTION: "Обычные действия",
};
